import React from "react";
import styled from "styled-components/macro";

const ShortcutButton = styled.div`
    ${({ theme }) => theme.bp.xs`
        width: 8em;
    `}
    ${({ theme }) => theme.bp.md`
        width: 118px;
    `}
    cursor: pointer;
    height: 32px;
    pointer-events: auto;
    font-size: ${props => props.theme.paragraph.fontSize};
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 4px;
    color: white;
    border: 1px solid white;
    margin: 0 10px;
    @media (hover) {
        &:hover {
            background: rgba(255, 255, 255, 0.2);
        }
    }
`;

const ShortcutButtonsContainer = styled.div`
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    position: absolute;
    margin: 30px;
    display: flex;
    z-index: 2;
`;

export const ShortcutButtons = ({
    items,
    handleShortcutButtonClick,
}: {
    items: any[];
    handleShortcutButtonClick: (itemId: string) => void;
}) => {
    return (
        <ShortcutButtonsContainer>
            {items.map((item: any) => {
                if (!item.name || !item.id) return null;

                return (
                    <ShortcutButton key={item.id} onClick={() => handleShortcutButtonClick(item.id)}>
                        <p>{item.name.toUpperCase()}</p>
                    </ShortcutButton>
                );
            })}
        </ShortcutButtonsContainer>
    );
};
